module.exports = __webpack_public_path__ + "static/img/app_coder1.e7c64ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_coder1.png
// module id = oOTP
// module chunks = 5